var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notams-main"},_vm._l((_vm.DataList),function(post){return _c('div',{key:post.idx},_vm._l((post.NotamInfoList),function(p){return _c('div',{key:p.idx},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.getValueWithImportantWord(p.NotamInfo))}})])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }